import {query} from 'api';
import PropTypes from 'prop-types';
import RecipeSlide from './recipeSlide';
import RecipeList from './recipeList';
import RecipeCircleList from './recipeCircleList';
import RecipeConseils from './recipeConseils';
import {Container, Slides} from './styles';
import {withState} from 'recompose';

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  arrows: false,
  variableWidth: true,
};

const Recipes = ({data, selectedCategory, setSelectedCategory}) => {
  if (!data) return null;
  const pageTitle = data.acf.recettes_titre;
  const subTitle = data.acf.recettes_sous_titre.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, '');

  return (
    <Container className="slides">
      <Slides {...settings}>
        {data.acf.recettes_slider.map(slideData => (
          <RecipeSlide
            {...slideData}
            pageTitle={pageTitle}
            subTitle={subTitle}
            key={slideData.recettes_slider_image}
            id={
              slideData.recettes_slider_image_mobile
                ? slideData.recettes_slider_image_mobile
                : slideData.recettes_slider_image
            }
            type="media"
          />
        ))}
      </Slides>
      <RecipeCircleList selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />
      <RecipeList categoryId={selectedCategory} />
      <RecipeConseils />
    </Container>
  );
};

Recipes.propTypes = {
  data: PropTypes.object,
  selectedCategory: PropTypes.number,
  setSelectedCategory: PropTypes.func.isRequired,
};

export default Recipes
  |> query('getRecipes', {loadingFullWidth: true})
  |> withState('selectedCategory', 'setSelectedCategory', null);
